import {
	SET_REMINDERS,
	CREATE_REMINDER,
	UPDATE_REMINDER,
	DELETE_REMINDER,
	SET_REMINDERS_LOADING,
	SET_REMINDERS_ERROR,
} from '@/actions/types';

const initialState = {
	reminders: [],
	loading: false,
	error: null,
};

export default function reminders(state = initialState, action) {
	switch (action.type) {
		case SET_REMINDERS:
			return {
				...state,
				reminders: action.payload || [], // Corrected: action.payload is the array of reminders
				loading: false,
				error: null,
			};
		case CREATE_REMINDER:
			return {
				...state,
				reminders: [action.payload, ...state.reminders],
				loading: false,
			};
		case UPDATE_REMINDER:
			return {
				...state,
				reminders: state.reminders.map((reminder) =>
					reminder._id === action.payload._id
						? action.payload
						: reminder
				),
				loading: false,
			};
		case DELETE_REMINDER:
			return {
				...state,
				reminders: state.reminders.filter(
					(reminder) => reminder._id !== action.payload
				),
				loading: false,
			};
		case SET_REMINDERS_LOADING:
			return {
				...state,
				loading: action.payload,
			};
		case SET_REMINDERS_ERROR:
			return {
				...state,
				error: action.payload,
				loading: false,
			};
		default:
			return state;
	}
}
